export default {"src":"/_next/static/media/logo-symbol.409db9f2.svg","height":35,"width":44,"blurWidth":0,"blurHeight":0};